// Firebase configuration - replace with your config
export const firebaseConfig = {
    apiKey: "AIzaSyAcwRRxI5nT-zhPHycNOwHJsMICqJp0g8Q",
    authDomain: "atomz-9937c.firebaseapp.com",
    projectId: "atomz-9937c",
    storageBucket: "atomz-9937c.firebasestorage.app",
    messagingSenderId: "441030972566",
    appId: "1:441030972566:web:dfd4b92280d59a33d2deb7",
    measurementId: "G-DHW27EYTBP"
  };